export hero from './hero';



// WEBPACK FOOTER //
// ./app/config/context/homepage/index.js